var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 336,
    viewBox: "0 0 470 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_52_11249)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 338.5,
    r: 184.5,
    fill: "#8646F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_52_11249",
    x: -608,
    y: -346,
    width: 1369,
    height: 1369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_52_11249"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur10);
export default __webpack_public_path__ + "static/media/blur-10.c45bec1d15360330ef99835d1e41cd95.svg";
export { ForwardRef as ReactComponent };